import { generateMnemonic } from "bip39";
import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./CreateWallet.css"
import "./Phrase.css"

export default function CreateWallet() {

    const [mnemonic, setMnemonic] = React.useState<string[]>([])
    const [stage, setStage] = React.useState(1);
    const [password, setPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');

    const navigate  = useNavigate()
    React.useEffect(() => {
        setMnemonic(generateMnemonic().split(" "))
    }, [])
    return (
        <div className="MuiGrid-root MuiGrid-container css-h8l44m">
            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-7 MuiGrid-grid-md-6 jss18 css-1jpyr5b">
                <div className="MuiContainer-root MuiContainer-maxWidthSm jss19 css-1m6pqln">
                    <div className="MuiBox-root css-k3gutg">
                        <div className="MuiBox-root css-0">
                            <a
                                className="MuiButtonBase-root css-1b47e06"
                                tabIndex={0}
                                data-id="solflare_logo"
                                href="/"
                            >
                                <img
                                    src="https://solflare.com/assets/logo.26659b6d..svg"
                                    alt="Solflare logo"
                                    className="solriseLogoImage"
                                />
                            </a>
                            <div className="MuiBox-root css-1kaojm3">
                                <a
                                    className="MuiButtonBase-root css-1b47e06"
                                    tabIndex={0}
                                    data-id="solflare"
                                    href="/"
                                >
                                    <img src="https://solflare.com/assets/solflare.18da1228..svg" alt="Solflare" />
                                </a>
                            </div>
                        </div>
                        <div className="MuiBox-root css-0">
                            <button
                                className="MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButtonBase-root css-1rryh4p"
                                tabIndex={0}
                                type="button"
                                data-id="translate_button"
                            >
                                <svg
                                    className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv"
                                    focusable="false"
                                    aria-hidden="true"
                                    viewBox="0 0 24 24"
                                    data-testid="TranslateIcon"
                                >
                                    <path d="m12.87 15.07-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7 1.62-4.33L19.12 17h-3.24z" />
                                </svg>
                            </button>
                        </div>
                    </div>
                    {
                        stage === 1 && (
                            <div className="MuiBox-root css-0">
                                <h2 className="MuiTypography-root MuiTypography-h2 MuiTypography-gutterBottom css-1tc4wys">
                                    Write down your Recovery Phrase
                                </h2>
                                <p className="MuiTypography-root MuiTypography-body2 css-1dgj0bz">
                                    You will need it on the next step
                                </p>
                                <div className="jss27 MuiBox-root css-0">
                                    <div className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-2 jss28 css-isbt42">
                                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-6 MuiGrid-grid-sm-4 css-nlcweg">
                                            <p
                                                className="MuiTypography-root MuiTypography-body1 jss29 css-1362g6f"
                                                data-index={1}
                                                translate="no"
                                            >
                                                {mnemonic[0]}
                                            </p>
                                        </div>
                                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-6 MuiGrid-grid-sm-4 css-nlcweg">
                                            <p
                                                className="MuiTypography-root MuiTypography-body1 jss29 css-1362g6f"
                                                data-index={2}
                                                translate="no"
                                            >
                                                {mnemonic[1]}
                                            </p>
                                        </div>
                                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-6 MuiGrid-grid-sm-4 css-nlcweg">
                                            <p
                                                className="MuiTypography-root MuiTypography-body1 jss29 css-1362g6f"
                                                data-index={3}
                                                translate="no"
                                            >
                                                {mnemonic[2]}
                                            </p>
                                        </div>
                                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-6 MuiGrid-grid-sm-4 css-nlcweg">
                                            <p
                                                className="MuiTypography-root MuiTypography-body1 jss29 css-1362g6f"
                                                data-index={4}
                                                translate="no"
                                            >
                                                {mnemonic[3]}
                                            </p>
                                        </div>
                                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-6 MuiGrid-grid-sm-4 css-nlcweg">
                                            <p
                                                className="MuiTypography-root MuiTypography-body1 jss29 css-1362g6f"
                                                data-index={5}
                                                translate="no"
                                            >
                                                {mnemonic[4]}
                                            </p>
                                        </div>
                                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-6 MuiGrid-grid-sm-4 css-nlcweg">
                                            <p
                                                className="MuiTypography-root MuiTypography-body1 jss29 css-1362g6f"
                                                data-index={6}
                                                translate="no"
                                            >
                                                {mnemonic[5]}
                                            </p>
                                        </div>
                                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-6 MuiGrid-grid-sm-4 css-nlcweg">
                                            <p
                                                className="MuiTypography-root MuiTypography-body1 jss29 css-1362g6f"
                                                data-index={7}
                                                translate="no"
                                            >
                                                {mnemonic[6]}
                                            </p>
                                        </div>
                                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-6 MuiGrid-grid-sm-4 css-nlcweg">
                                            <p
                                                className="MuiTypography-root MuiTypography-body1 jss29 css-1362g6f"
                                                data-index={8}
                                                translate="no"
                                            >
                                                {mnemonic[7]}
                                            </p>
                                        </div>
                                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-6 MuiGrid-grid-sm-4 css-nlcweg">
                                            <p
                                                className="MuiTypography-root MuiTypography-body1 jss29 css-1362g6f"
                                                data-index={9}
                                                translate="no"
                                            >
                                                {mnemonic[8]}
                                            </p>
                                        </div>
                                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-6 MuiGrid-grid-sm-4 css-nlcweg">
                                            <p
                                                className="MuiTypography-root MuiTypography-body1 jss29 css-1362g6f"
                                                data-index={10}
                                                translate="no"
                                            >
                                                {mnemonic[9]}
                                            </p>
                                        </div>
                                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-6 MuiGrid-grid-sm-4 css-nlcweg">
                                            <p
                                                className="MuiTypography-root MuiTypography-body1 jss29 css-1362g6f"
                                                data-index={11}
                                                translate="no"
                                            >
                                                {mnemonic[10]}
                                            </p>
                                        </div>
                                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-6 MuiGrid-grid-sm-4 css-nlcweg">
                                            <p
                                                className="MuiTypography-root MuiTypography-body1 jss29 css-1362g6f"
                                                data-index={12}
                                                translate="no"
                                            >
                                                {mnemonic[11]}
                                            </p>
                                        </div>
                                    </div>
                                    <hr className="MuiDivider-root MuiDivider-fullWidth MuiDivider-light css-1v8dmcj" />
                                    <div className="MuiBox-root css-1dqn28w">
                                        <button
                                            className="MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButtonBase-root css-1rryh4p"
                                            tabIndex={0}
                                            type="button"
                                            onClick={() => toast.success('copied to clipboard')}
                                        >
                                            Copy
                                        </button>
                                        <button
                                            className="MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButtonBase-root css-1rryh4p"
                                            tabIndex={0}
                                            disabled

                                        >
                                            Download
                                        </button>
                                    </div>
                                </div>
                                <div className="MuiBox-root css-1t6p38n">
                                    <button
                                        className="MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButtonBase-root css-1rryh4p"
                                        tabIndex={0}
                                        type="button"
                                        onClick={() => navigate("/")}
                                    >
                                        Back
                                    </button>
                                    <button
                                        className="MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-sizeMedium MuiButton-containedSizeMedium MuiButtonBase-root css-7nmrms"
                                        tabIndex={0}
                                        type="button"
                                        onClick={() => setStage(2)}
                                    >
                                        I SAVED MY RECOVERY PHRASE
                                    </button>
                                </div>
                            </div>
                        )
                    }

                    {
                        stage === 2 && (
                            <div className="MuiBox-root css-0">
                                <h2 className="MuiTypography-root MuiTypography-h2 MuiTypography-gutterBottom css-1tc4wys">
                                    Set a passcode for your wallet
                                </h2>
                                <form onSubmit={(e) => {
                                    e.preventDefault();
                                    if (password !== confirmPassword) {
                                        toast.error('passwords don\'t match')
                                    } else {
                                        setStage(3)
                                    }
                                }}>
                                    <div className="jss15 MuiBox-root css-0">
                                        <div className="MuiBox-root css-1qm1lh">
                                            <div className="MuiFormControl-root MuiFormControl-fullWidth MuiTextField-root css-t951g0">
                                                <label
                                                    className="MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-sizeSmall MuiInputLabel-standard MuiFormLabel-root MuiFormLabel-colorPrimary css-ipi1j4"
                                                    data-shrink="false"
                                                    htmlFor=":r1:"
                                                    id=":r1:-label"
                                                >
                                                    {password === "" && "New Password"}
                                                </label>
                                                <div className="MuiInput-root MuiInput-underline MuiInputBase-root MuiInputBase-colorPrimary MuiInputBase-fullWidth MuiInputBase-formControl MuiInputBase-sizeSmall css-er1iuk">
                                                    <input
                                                        aria-invalid="false"
                                                        value={password}
                                                        onChange={(e) => setPassword(e.target.value)}
                                                        type="password"
                                                        className="MuiInput-input MuiInputBase-input MuiInputBase-inputSizeSmall css-6i5tlx"

                                                        data-ddg-inputtype="credentials.password"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="MuiBox-root css-1qm1lh">
                                            <div className="MuiFormControl-root MuiFormControl-fullWidth MuiTextField-root css-t951g0">
                                                <label
                                                    className="MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-sizeSmall MuiInputLabel-standard MuiFormLabel-root MuiFormLabel-colorPrimary css-ipi1j4"
                                                    data-shrink="false"
                                                    htmlFor=":r2:"
                                                    id=":r2:-label"
                                                >
                                                    {confirmPassword === "" && "Reapeat Password"}
                                                </label>
                                                <div className="MuiInput-root MuiInput-underline MuiInputBase-root MuiInputBase-colorPrimary MuiInputBase-fullWidth MuiInputBase-formControl MuiInputBase-sizeSmall css-er1iuk">
                                                    <input
                                                        aria-invalid="false"
                                                        value={confirmPassword}
                                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                                        className="MuiInput-input MuiInputBase-input MuiInputBase-inputSizeSmall css-6i5tlx"
                                                        type="password"
                                                        data-ddg-inputtype="credentials.password"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="MuiBox-root css-163v3sq">
                                        <button
                                            className="MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButtonBase-root css-1rryh4p"
                                            tabIndex={0}
                                            type="button"
                                            onClick={() => setStage(1)}
                                        >
                                            Back
                                        </button>
                                        <button
                                            className="MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-sizeMedium MuiButton-containedSizeMedium MuiButtonBase-root Mui-disabled css-7nmrms"
                                            tabIndex={-1}
                                            type="submit"
                                            disabled={password === "" || confirmPassword === ""}
                                        >
                                            Continue
                                        </button>
                                    </div>
                                </form>
                            </div>
                        )
                    }

                    {
                        stage === 3 && (
                            <div className="MuiBox-root css-12dtbqf">
                                <div className="jss16 MuiBox-root css-1ag1foi">
                                    <svg
                                        className="MuiSvgIcon-root MuiSvgIcon-colorPrimary MuiSvgIcon-fontSizeMedium css-1nounmf"
                                        focusable="false"
                                        aria-hidden="true"
                                        viewBox="0 0 24 24"
                                        data-testid="AccountBalanceWalletIcon"
                                        style={{ fontSize: "50px" }}
                                    >
                                        <path d="M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" />
                                    </svg>
                                </div>
                                <div className="MuiBox-root css-1fkzs83">
                                    <h2 className="MuiTypography-root MuiTypography-h2 MuiTypography-gutterBottom css-1tc4wys">
                                        Wallet Imported
                                    </h2>
                                    <p className="MuiTypography-root MuiTypography-body2 css-1dgj0bz">
                                        congrats your wallet has been successfully imported
                                    </p>
                                    <div className="MuiBox-root css-1sfbpg5">
                                        <button
                                            className="MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-sizeMedium MuiButton-containedSizeMedium MuiButtonBase-root css-7nmrms"
                                            tabIndex={0}
                                            type="button"
                                        >
                                            Finish setup
                                        </button>

                                    </div>
                                </div>
                            </div>
                        )
                    }
                    <div className="MuiBox-root css-12waxkz">
                        Already have a wallet?{" "}
                        <a
                            className="MuiTypography-root MuiTypography-inherit MuiLink-root MuiLink-underlineHover css-199nb6s"
                            href="/onboard/access"
                        >
                            Access it here
                        </a>
                    </div>
                </div>
            </div>
            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-5 MuiGrid-grid-md-6 css-ye2qiz">
                <div className="jss23 MuiBox-root css-0">
                    <div className="carousel-root">
                        <div
                            className="carousel carousel-slider"
                            style={{ width: "100%" }}
                        >
                            <ul className="control-dots">
                                <li
                                    className="dot"
                                    value={0}
                                    role="button"
                                    tabIndex={0}
                                    aria-label="slide item 1"
                                />
                                <li
                                    className="dot"
                                    value={1}
                                    role="button"
                                    tabIndex={0}
                                    aria-label="slide item 2"
                                />
                                <li
                                    className="dot selected"
                                    value={2}
                                    role="button"
                                    tabIndex={0}
                                    aria-label="slide item 3"
                                />
                            </ul>
                            <button
                                type="button"
                                aria-label="previous slide / item"
                                className="control-arrow control-prev control-disabled"
                            />
                            <div className="slider-wrapper axis-horizontal">
                                <ul
                                    className="slider animated"
                                    style={{
                                        transform: "translate3d(-200%, 0px, 0px)",
                                        transitionDuration: "350ms",
                                    }}
                                >
                                    <li className="slide">
                                        <div className="MuiBox-root css-w5i18h">
                                            <img
                                                src="https://solflare.com/assets/carousel-image-phrase.a4e711a6..svg"
                                                alt=""
                                                className="jss24"
                                            />
                                            <h3
                                                className="MuiTypography-root MuiTypography-h3 MuiTypography-gutterBottom css-1j1km3d"
                                                data-id="carouse_title"
                                            >
                                                Your recovery phrase is a backup key for your wallet.
                                            </h3>
                                            <p
                                                className="MuiTypography-root MuiTypography-body2 css-1dgj0bz"
                                                data-id="carousel_text"
                                            >
                                                You'll be able to log in to your wallet with a
                                                passcode, but if you will need your recovery phrase to
                                                access it.
                                            </p>
                                        </div>
                                    </li>
                                    <li className="slide">
                                        <div className="MuiBox-root css-w5i18h">
                                            <img
                                                src="https://solflare.com/assets/carousel-image-write-down.9565a9f3..svg"
                                                alt=""
                                                className="jss24"
                                            />
                                            <h3
                                                className="MuiTypography-root MuiTypography-h3 MuiTypography-gutterBottom css-1j1km3d"
                                                data-id="carouse_title"
                                            >
                                                Write it down!
                                            </h3>
                                            <p
                                                className="MuiTypography-root MuiTypography-body2 css-1dgj0bz"
                                                data-id="carousel_text"
                                            >
                                                It's highly recommended to write down your recovery
                                                phrase and store it in a safe place so you don't risk
                                                losing your funds.
                                            </p>
                                        </div>
                                    </li>
                                    <li className="slide selected previous">
                                        <div className="MuiBox-root css-w5i18h">
                                            <img
                                                src="https://solflare.com/assets/carousel-image-secure.e97295fe..svg"
                                                alt=""
                                                className="jss24"
                                            />
                                            <h3
                                                className="MuiTypography-root MuiTypography-h3 MuiTypography-gutterBottom css-1j1km3d"
                                                data-id="carouse_title"
                                            >
                                                Never share your recovery phrase with anyone!
                                            </h3>
                                            <p
                                                className="MuiTypography-root MuiTypography-body2 css-1dgj0bz"
                                                data-id="carousel_text"
                                            >
                                                Anyone who has it can access your funds from anywhere.
                                                Keep it secure!
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <button
                                type="button"
                                aria-label="next slide / item"
                                className="control-arrow control-next control-disabled"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
